export * from './p.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/micro-components/p-component/index.ts